<template lang="pug">
.homepageSection3Component(id="about")
  homepage-showcase-block(
    :model="data"
    color-scheme="pink"
    :cursor="cursor"
  )
</template>

<script>
import homepageData from '@/mocks/homepage.json'
import HomepageShowcaseBlock from './HomepageShowcaseBlock/HomepageShowcaseBlock'
export default {
  components: {
    HomepageShowcaseBlock
  },
  props: {
    cursor: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    }
  },
  setup () {
    const data = homepageData.section3

    return {
      data
    }
  }
}
</script>

<style lang="sass" scoped>
.homepageSection3Component
</style>
